<template>
  <div>

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue